import { message } from "antd";
import Joi from "joi-browser";
import { useMemo, useState } from "react";
import Form from "V2.0/components/Form";
import { putTTSSettings } from "../../service";

interface GooglettsSettings {
  googleSpeechRate: number;
  googleVoicePitch: number;
}

const template = [
  {
    name: "googleSpeechRate",
    label: "Speed",
    description: "Controls the speed of the generated speech",
    type: "slider",
    min: 0.25,
    max: 4,
    step: 0.1,
  },
  {
    name: "googleVoicePitch",
    label: "Voice Pitch",
    description: "",
    type: "slider",
    min: -10,
    max: 10,
    step: 1,
  },
];

const schema = {
  googleSpeechRate: Joi.number(),
  googleVoicePitch: Joi.number(),
};

function getGooglettsConfigurableSettings(settings) {
  const { googleSpeechRate, googleVoicePitch } = settings;

  return {
    googleSpeechRate,
    googleVoicePitch,
  };
}

function GoogleTTS(props) {
  const {
    googleTTSSettings,
    ttsServiceProvider,
    syncAssistant,
    workspaceId,
    assistantId,
    onClose,
  } = props;

  const [loading, setLoading] = useState(false);
  const [errorMessage] = useState({});

   const inputField = useMemo(() => {
      return getGooglettsConfigurableSettings(googleTTSSettings);
    }, [googleTTSSettings]);

  const handleSaveSettings = async (data) => {
    setLoading(true);
    message.loading("Saving");

    const payload = {
      ttsServiceProvider,
      googleTTSSettings: data,
    };

    try {
      const response = await putTTSSettings({
        workspaceId,
        assistantId,
        payload,
      });

      if (response.status === 200) {
        message.destroy();
        setLoading(false);
        message.success("Saved");
        syncAssistant((prevAssistant) => {
          return { ...prevAssistant, ttsSettings: response.data };
        });
        onClose();
      }
    } catch (e) {
      setLoading(false);

      message.destroy();
      message.error(e.response.data?.msg || e.response.data?.message || e.response.data?.error || "Failed to save settings");
    }
  };

  return (
    <div>
      <Form
        inputField={inputField}
        template={template}
        schema={schema}
        buttonInfo={{ label: "Save", style: "right-side" }}
        loading={loading}
        setLoading={setLoading}
        onSubmit={handleSaveSettings}
      />
    </div>
  );
}

export default GoogleTTS;
